<template>
  <v-dialog persistent v-model="dialog" max-width="1000px" scrollable>
    <v-card id="qj-dialog-stimulus">
      <!-- Cabeçalho -->
      <v-card-title class="headline py-2" primary-title>
        {{ dialogTitle }}
        <v-spacer></v-spacer>
        <v-btn class="ma-0" icon @click="$emit('update:dialog', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <!-- Corpo -->
      <v-card-text class="pa-0">
        <v-form ref="form" lazy-validation>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  box
                  hide-details
                  label="Nome"
                  v-model="newStimulus.name" />
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  box
                  required
                  hide-details
                  label="Nó*"
                  item-value="id"
                  item-text="fullText"
                  :disabled="loadingNodes"
                  :items="nodes"
                  :loading="loadingNodes"
                  v-model="newStimulus.debt_node_id"
                  menu-props="offsetY">
                  <template v-slot:selection="{ item }">
                    {{ item.text }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="newStimulus.approach_flow_id"
                  success
                  hide-details
                  :disabled="loadingNodes || loadingDialog"
                  :loading="loadingNodes || loadingDialog"
                  :items="approachList"
                  label="Fluxos de Abordagem*"
                  flat
                  no-data-text="Sem dados"
                  box
                  item-text="name"
                  item-value="id"
                  menu-props="offsetY">
                </v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  v-model="filters.creditors_mode"
                  success
                  :items="creditorsModeOptions"
                  label="Abordar Credor"
                  flat
                  no-data-text="Sem dados"
                  box
                  hide-details
                  item-text="name"
                  item-value="id"
                  menu-props="offsetY">
                </v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-combobox
                  number
                  box
                  chips
                  multiple
                  clearable
                  small-chips
                  name="amount_deals"
                  label="Quantidade mínima de dívidas"
                  v-model="amountDealsModel"
                  :items="['1', '2', '3', '4', '>=5']">
                  <template v-slot:no-data></template>
                </v-combobox>
              </v-flex>

              <v-flex xs12 class="pb-0 mt-0 pt-0">
                <v-subheader class="px-1">Qualidade</v-subheader>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                  box
                  hint
                  hide-details
                  type="number"
                  label="Qualidade Mínima"
                  name="contact_min_final_score"
                  v-model="filters.min_quality">
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <small>
                        A qualidade de um contato novo começa em
                        <strong>0</strong>. <br />Valores menores que <strong>1</strong> são
                        considerados de baixa qualidade. <br />Ex:
                        <strong>0, 0.10, 0.25, 0.50, 0.80, 1</strong>
                      </small>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                  box
                  hint
                  hide-details
                  type="number"
                  label="Qualidade Máxima"
                  name="contact_max_final_score"
                  v-model="filters.max_quality">
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <small>
                        A qualidade de um contato novo começa em
                        <strong>0</strong>. <br />Valores menores que <strong>1</strong> são
                        considerados de baixa qualidade. <br />Ex:
                        <strong>0, 0.10, 0.25, 0.50, 0.80, 1</strong>
                      </small>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>

              <v-flex xs12 class="pb-0 mt-0 pt-0">
                <v-subheader class="px-1">Digito Verificador</v-subheader>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-text-field
                  box
                  hide-details
                  type="number"
                  label="Digito Verificador de"
                  name="min_digit"
                  v-model="filters.min_digit" />
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  box
                  hide-details
                  type="number"
                  label="Digito Verificador até"
                  name="max_digit"
                  v-model="filters.max_digit" />
              </v-flex>

              <v-flex xs12 class="pb-0 mt-0 pt-0">
                <v-subheader class="px-1">Contatos</v-subheader>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-select
                  box
                  :items="[1, 2, 3, 4, 5]"
                  label="Qtd. máx. de contatos"
                  name="max_contact_count"
                  v-model="filters.max_contact_count"
                  clearable
                  menu-props="offsetY">
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <p>Limita a quantidade de contatos a serem notificados por cliente</p>
                    </v-tooltip>
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 md6 lg6>
                <v-text-field
                  box
                  hint
                  hide-details
                  type="number"
                  label="Idade do contato"
                  suffix="dias"
                  name="contact_age"
                  v-model="filters.contact_age">
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <p>Filtra os contatos que foram criados de X dias atrás até hoje (EM DIAS)</p>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>

              <v-flex xs12 class="pb-0 mt-0 pt-0">
                <v-subheader class="px-1">Notificações</v-subheader>
              </v-flex>
              <v-flex xs12 md3 lg3>
                <v-text-field
                  hide-details
                  type="number"
                  name="min_notifications"
                  label="Mín. de Notificações"
                  v-model="filters.min_stimulation"
                  box>
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <p>
                        Quantidade mínima de notificações que os contatos receberam neste credor!
                      </p>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md3 lg3>
                <v-text-field
                  hide-details
                  type="number"
                  name="max_notifications"
                  label="Máx. de Notificações"
                  v-model="filters.max_stimulation"
                  box>
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <p>
                        Quantidade máxima de notificações que os contatos receberam neste credor!
                      </p>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>

              <v-flex xs12 md3 lg3>
                <v-text-field
                  hide-details
                  type="number"
                  name="days_to_wait"
                  label="Dias de espera"
                  suffix="dias"
                  min="0"
                  v-model="filters.days_to_wait"
                  box>
                  <template v-slot:prepend-inner>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          style="font-size: 20px; cursor: help; margin-top: 2px"
                          color="grey"
                          v-on="on"
                          >help</v-icon
                        >
                      </template>
                      <p>
                        Considera contatos cuja última notificação foi há pelo menos X dias.
                      </p>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>

              <v-flex row xs12 md3 lg3>
                <div class="d-flex align-center">
                  <v-switch
                    class="my-2"
                    hide-details
                    v-model="ignore_optin"
                    label="Sem Opt-In"></v-switch>
                </div>
              </v-flex>

              <v-flex xs12>
                <v-subheader class="px-1">
                  Dias desde a última interação
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon style="font-size: 18px; cursor: help" color="grey" v-on="on"
                        >help</v-icon
                      >
                    </template>
                    <small class="body-2">
                      Inclusão de ranges de interação, onde [x] é definido como: clientes que
                      interagiram pela última vez DE: [0] dias ATÉ: [30] dias.
                    </small>
                  </v-tooltip>
                </v-subheader>
              </v-flex>

              <v-flex xs12 md3 lg3>
                <v-text-field
                  hide-details
                  type="number"
                  name="max_interaction_days"
                  label="Interação de:"
                  suffix="dias"
                  v-model="filters.max_interaction_days"
                  :items="[]"
                  :disabled="filters.exclude_interactions"
                  box></v-text-field>
              </v-flex>

              <v-flex xs12 md3 lg3>
                <v-text-field
                  hide-details
                  type="number"
                  name="min_interaction_days"
                  label="Interação até:"
                  suffix="dias"
                  v-model="filters.min_interaction_days"
                  :items="[]"
                  :disabled="filters.exclude_interactions"
                  box></v-text-field>
              </v-flex>

              <v-flex xs12 md3 lg3>
                <v-switch
                  class="my-2"
                  hide-details
                  v-model="filters.exclude_interactions"
                  label="Sem interação"></v-switch>
              </v-flex>

              <v-flex xs12>
                <v-subheader class="px-1">Dias desde o último acordo expirado</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-layout style="gap: 1rem" row>
                  <v-flex xs12 md6 xs6>
                    <v-text-field
                      type="number"
                      label="Quebra de:"
                      suffix="dias"
                      autocomplete="off"
                      name="max_payment_expired_days"
                      min="0"
                      v-model="filters.max_payment_expired_days"
                      box />
                  </v-flex>
                  <v-flex xs12 md6 xs6>
                    <v-text-field
                      type="number"
                      label="Quebra até:"
                      suffix="dias"
                      autocomplete="off"
                      name="min_payment_expired_days"
                      min="0"
                      v-model="filters.min_payment_expired_days"
                      box />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <v-subheader class="px-1">Interações por canal {{ interactionsCounter }}
                </v-subheader>
              </v-flex>

              <v-flex
                xs12
                v-for="interaction in interactions"
                :key="`filter-interaction-${interaction.name}`"
                v-if="interaction.active"
                class="px-4 py-2 mx-2 mb-2 interaction-option">
                <qj-filter-interaction
                  @removeInteraction="removeInteraction"
                  :excludeInteractions.sync="filters[`exclude_interactions_${interaction.name}`]"
                  :maxInteractionDays.sync="filters[`max_interaction_days_${interaction.name}`]"
                  :minInteractionDays.sync="filters[`min_interaction_days_${interaction.name}`]"
                  :name="interaction.name"
                  :title="interaction.title" />
              </v-flex>

              <v-flex xs12 pa-0 v-if="interactions.some((interaction) => !interaction.active)">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" color="primary" flat>
                      <v-icon>add</v-icon>
                      Interação por canal
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-tile
                      v-for="interaction in interactions.filter(
                        (interaction) => !interaction.active
                      )"
                      :key="interaction.suffix"
                      @click="addInteraction(interaction)">
                      <v-list-tile-title>
                        {{ interaction.title }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </v-flex>

              <v-flex xs12 md12>
                <v-autocomplete
                  box
                  hide-details
                  clearable
                  name="campaign_v2"
                  label="Campanhas"
                  :items="campaigns"
                  :item-text="(campaigns) => campaigns.key"
                  v-model="campaignModelV2">
                  <template v-slot:no-data="{ item }">
                    <div>
                      <p>{{ item.key }}</p>
                    </div>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12 md6>
                <v-combobox
                  box
                  required
                  hide-details
                  clearable
                  small-chips
                  item-text="name"
                  label="Segmentos"
                  :items="SegmentFilter.length > 1 ? SegmentFilter : segments"
                  v-model="segmentModel"
                  multiple
                  menu-props="offsetY">
                  <template v-slot:no-data="{ item, index }">
                    {{ item.name }}
                  </template>
                </v-combobox>
              </v-flex>

              <v-flex xs12 md6>
                <v-combobox
                  box
                  multiple
                  clearable
                  hide-details
                  small-chips
                  name="creditor_profiles"
                  label="Chave de perfil de credor"
                  :items="
                    creditoProfilesFilter.length > 1 ? creditoProfilesFilter : creditor_profiles
                  "
                  item-text="name"
                  v-model="profileKeyModel">
                  <template v-slot:no-data="{ item, index }">
                    {{ item.name }}
                  </template>
                </v-combobox>
              </v-flex>

              <v-flex xs6 md6 class="pb-0">
                <v-subheader class="px-1"
                  >Tags
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" v-on="on">help</v-icon>
                    </template>
                    <span> Filtros destinados aos tageamentos de deals e contatos. </span>
                  </v-tooltip>
                </v-subheader>
              </v-flex>

              <v-flex xs12 md12>
                <v-combobox
                  box
                  multiple
                  clearable
                  small-chips
                  name="tags_v2"
                  label="Tags da Negociação - campo inclusivo"
                  :items="tagsFilter.length > 1 ? tagsFilter : tags_v2"
                  item-text="name"
                  v-model="dealTagsModelV2"
                  hide-details
                  menu-props="offsetY">
                  <template v-slot:no-data="{ item, index }">
                    {{ item.name }}
                  </template>
                </v-combobox>
              </v-flex>
              <v-flex xs12 md12>
                <v-combobox
                  box
                  multiple
                  clearable
                  small-chips
                  hide-selected
                  hide-details
                  name="contact_tags_v2"
                  label="Tags de Contato"
                  hint="Deixe em branco para não considerar negociações com tags."
                  v-model="contactTagsModel"
                  item-text="name"
                  :items="contactTagsFilter.length > 1 ? contactTagsFilter : contact_tags_v2"
                  menu-props="offsetY">
                </v-combobox>
                <template v-slot:no-data="{ item, index }">
                  {{ item.name }}
                </template>
              </v-flex>

              <v-flex class="mb-4" xs12 md12>
                <v-combobox
                  box
                  multiple
                  clearable
                  small-chips
                  hide-selected
                  hide-details
                  name="customer_tag"
                  label="Tags de Cliente"
                  hint="Deixe em branco para não considerar negociações com tags."
                  v-model="customerTagsModel"
                  item-text="name"
                  :items="customerTagsFilter.length > 1 ? customerTagsFilter : customer_tag"
                  menu-props="offsetY">
                </v-combobox>
                <template v-slot:no-data="{ item, index }">
                  {{ item.name }}
                </template>
              </v-flex>

              <v-flex xs12 v-if="!dataTest.hot">
                <v-switch hide-details class="ma-0 pa-0" v-model="filters.include_unchecked">
                  <template v-slot:label>
                    Incluir não verificados
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon class="ml-1" v-on="on">help</v-icon>
                      </template>
                      <span>
                        Desconsidera contatos que recebemos retorno de não entrega da mensagem.
                      </span>
                    </v-tooltip>
                  </template>
                </v-switch>
              </v-flex>

              <v-flex xs6 md6 class="pb-0">
                <v-subheader class="px-1"
                  >Contatos
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" v-on="on">help</v-icon>
                    </template>
                    <span> Filtro de contatos destinado à empresas. </span>
                  </v-tooltip>
                </v-subheader>
              </v-flex>
              <v-flex xs6 md6 class="pb-0">
                <v-subheader class="px-1"
                  >Origem dos Contatos
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" v-on="on">help</v-icon>
                    </template>
                    <span> Filtro da origem dos contatos. </span>
                  </v-tooltip>
                </v-subheader>
              </v-flex>

              <v-flex xs6 md6>
                <v-select
                  :items="[
                    {
                      id: 'OWNER',
                      text: 'Próprio',
                    },
                    {
                      id: 'ASSOCIATE',
                      text: 'Sócios',
                    },
                    {
                      id: 'GUARANTOR',
                      text: 'Avalistas',
                    },
                  ]"
                  v-model="responsibleTypes"
                  item-text="text"
                  item-value="id"
                  box
                  small-chips
                  clearable
                  label="Contatos"
                  multiple
                  menu-props="offsetY">
                  <template v-slot:selection="{ item, index }">
                    <span>
                      {{ index === 0 ? item.text : ", " + item.text }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs6 md6>
                <v-select
                  :items="[
                    {
                      id: 'CREDITOR',
                      text: 'Credor',
                    },
                    {
                      id: 'PARTNER',
                      text: 'Enriquecimento',
                    },
                    {
                      id: 'CUSTOMER',
                      text: 'Cliente',
                    },
                    {
                      id: 'OPERATOR',
                      text: 'Backoffice',
                    },
                  ]"
                  v-model="contactsSource"
                  item-text="text"
                  item-value="id"
                  box
                  small-chips
                  clearable
                  label="Origem dos Contatos"
                  multiple
                  menu-props="offsetY">
                  <template v-slot:selection="{ item, index }">
                    <span>
                      {{ index === 0 ? item.text : ", " + item.text }}
                    </span>
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12>
                <v-select
                  name="ddd"
                  label="DDDs"
                  hint="Deixe em branco para considerar todos os DDDs."
                  v-model="filters.selected_ddd"
                  box
                  multiple
                  clearable
                  small-chips
                  :items="ddds"
                  menu-props="offsetY">
                  <template v-slot:no-data="{ item, index }">
                    {{ item }}
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 md12 class="pb-0">
                <v-subheader class="px-1">Controle de Custo</v-subheader>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  box
                  hide-details
                  type="number"
                  name="min_potential"
                  label="Orçamento Diário"
                  v-model="newStimulus.daily_budget" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="py-2">
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
          <v-switch
            v-if="!newStimulus.id"
            v-model="toTop"
            class="mr-3 mt-0 pt-0"
            label="Criar no topo"
            hide-details
          ></v-switch>
          <v-btn flat @click="$emit('update:dialog', false)">Cancelar</v-btn>
          <v-btn
            v-show="!dataTest.isClone"
            color="accent"
            class="ma-0"
            :disabled="!isValidForm || loadingNodes || loadingDialog"
            @click="saveStimulus"
          >
            Salvar
          </v-btn>
          <v-btn
            v-show="dataTest.isClone"
            color="accent"
            class="ma-0"
            :disabled="!isValidForm"
            @click="saveStimulus"
          >
            Clonar
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import stimulusService from "@/services/consolidation-tree/stimulus";
import FilterInteraction from "@/components/FilterInteraction";

import store from "@/store";

export default {
  props: [
    "dialog",
    "dataTest",
    "node",
    "creditorId",
    "cloneParams",
    "minOrder",
    "loadingNodes",
    "loadingDialog",
    "campaigns",
    "segments",
    "approachList",
    "creditor_profiles",
    "tags_v2",
    "contact_tags_v2",
    "customer_tag",
    "nodes",
  ],
  components: {
    "qj-filter-interaction": FilterInteraction,
  },
  data() {
    return {
      /** Filtros de interações dos contatos. */
      interactions: [
        {
          active: false,
          name: "sms_click",
          title: "Clique no link do SMS",
        },
        {
          active: false,
          name: "ura_answer",
          title: "Atendimento de ligação da URA",
        },
        {
          active: false,
          name: "whatsapp_view",
          title: "Leitura de mensagem do WhatsApp",
        },
        /*   {
          active: false,
          name: 'whatsapp_click',
          title: 'Clique em link do WhatsApp',
        }, */
        {
          active: false,
          name: "email_open",
          title: "Abertura de e-mail",
        },
        {
          active: false,
          name: "email_click",
          title: "Clique no link do e-mail",
        },
      ],

      loadingApproachFlow: false,
      creditoProfilesFilter: [],
      campaignModel: [],
      SegmentFilter: [],
      campaignModelV2: [],
      tagsFilter: [],
      contactTagsFilter: [],
      customerTagsFilter: [],
      segmentModel: [],
      profileKeyModel: [],
      dealTagsModelV2: [],
      contactTagsModel: [],
      customerTagsModel: [],
      amountDealsModel: [],
      segmentsList: [],
      creditorsModeOptions: [
        { name: "Todos", id: "ALL" },
        { name: "Multi credores", id: "MULTI" },
        { name: "Credor único", id: "SINGLE" },
      ],
      ddds: [
        { header: "Inclusão" },
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "21",
        "22",
        "24",
        "27",
        "28",
        "31",
        "32",
        "33",
        "34",
        "35",
        "37",
        "38",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "51",
        "53",
        "54",
        "55",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "68",
        "69",
        "71",
        "73",
        "74",
        "75",
        "77",
        "79",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99",
        { header: "Exclusão" },
        "-11",
        "-12",
        "-13",
        "-14",
        "-15",
        "-16",
        "-17",
        "-18",
        "-19",
        "-21",
        "-22",
        "-24",
        "-27",
        "-28",
        "-31",
        "-32",
        "-33",
        "-34",
        "-35",
        "-37",
        "-38",
        "-41",
        "-42",
        "-43",
        "-44",
        "-45",
        "-46",
        "-47",
        "-48",
        "-49",
        "-51",
        "-53",
        "-54",
        "-55",
        "-61",
        "-62",
        "-63",
        "-64",
        "-65",
        "-66",
        "-67",
        "-68",
        "-69",
        "-71",
        "-73",
        "-74",
        "-75",
        "-77",
        "-79",
        "-81",
        "-82",
        "-83",
        "-84",
        "-85",
        "-86",
        "-87",
        "-88",
        "-89",
        "-91",
        "-92",
        "-93",
        "-94",
        "-95",
        "-96",
        "-97",
        "-98",
        "-99",
      ],
      newStimulus: { filters: {} },
      filters: { creditors_mode: "ALL" },
      last_modification_user: {},
      exclude_interactions: false,
      toTop: false,
      responsibleTypes: [],
      contactsSource: [],
      ignore_optin: false
    };
  },
  computed: {
    dialogTitle() {
      return this.newStimulus.id
        ? "Editar " + (this.newStimulus.name || "estímulo")
        : "Novo estímulo";
    },
    interactionsCounter() {
      return '(' + this.interactions.filter((a) => a.active).length + ' / ' + this.interactions.length + ')';
    },
    isValidForm() {
      let valid = true;
      if (!this.newStimulus.approach_flow_id) valid = false;
      if (!this.newStimulus.name) valid = false;
      if (!this.newStimulus.debt_node_id) valid = false;

      // Validar nó
      return valid;
    },
  },
  watch: {
    async dialog() {
      if (this.dialog) {
        this.ignore_optin = this.dataTest.ignore_optin
        this.newStimulus = { ...this.dataTest };
        if (this.dataTest.daily_budget) {
          this.newStimulus.daily_budget = parseInt(this.dataTest.daily_budget);
        }
        this.filters = { ...this.dataTest.filters };
        if (this.filters.deal_campaigns && this.filters.deal_campaigns.length)
          this.campaignModel = this.filters.deal_campaigns;
        if (this.filters.segments && this.filters.segments.length)
          this.segmentModel = this.filters.segments;
        if (this.filters.selected_ddd && this.filters.selected_ddd.length)
          this.selected_ddd = this.filters.selected_ddd;
        if (this.filters.campaign && this.filters.campaign.length)
          this.campaignModelV2 = this.filters.campaign;

        if (this.filters.creditor_profiles && this.filters.creditor_profiles.length)
          this.profileKeyModel = this.filters.creditor_profiles;

        if (this.filters.amount_deals && this.filters.amount_deals.length)
          this.amountDealsModel = this.filters.amount_deals;

        if (this.filters.tags_v2 && this.filters.tags_v2.length)
          this.dealTagsModelV2 = this.filters.tags_v2;

        if (this.filters.contact_tags_v2 && this.filters.contact_tags_v2.length)
          this.contactTagsModel = this.filters.contact_tags_v2;

        if (this.filters.customer_tag && this.filters.customer_tag.length)
          this.customerTagsModel = this.filters.customer_tag;

        if (this.filters.responsible_types && this.filters.responsible_types.length)
          this.responsibleTypes = this.filters.responsible_types;
        if (this.filters.contacts_source && this.filters.contacts_source.length)
          this.contactsSource = this.filters.contacts_source;
      } else {
        this.contactTagsModel = [];
        this.customerTagsModel = [];
        this.dealTagsModelV2 = [];
        this.amountDealsModel = [];
        this.campaignModelV2 = [];
        this.segmentModel = [];
        this.profileKeyModel = [];
        this.newStimulus = {};
        this.responsibleTypes = [];
        this.contactsSource = [];
        this.SegmentFilter = [];
        this.creditoProfilesFilter = [];
        this.tagsFilter = [];
        this.contactTagsFilter = [];
        this.toTop = false;
      }

      // Verifica quais filtros de interação estão ativos
      this.interactions.forEach((interaction) => {
        for (const filterName in this.filters) {
          if (filterName.endsWith(interaction.name)) {
            interaction.active = true;
          }
        }
      });
    },
    async dealTagsModelV2() {
      if (this.dealTagsModelV2.includes("Sem-tags") && this.dealTagsModelV2.length > 1) {
        this.dealTagsModelV2 = ["Sem-tags"];
      }
    },
    async contactTagsModel() {
      if (this.contactTagsModel.includes("Sem-tags") && this.contactTagsModel.length > 1) {
        this.contactTagsModel = ["Sem-tags"];
      }
    },
    async customerTagsModel() {
      if (this.customerTagsModel.includes("Sem-tags") && this.customerTagsModel.length > 1) {
        this.customerTagsModel = ["Sem-tags"];
      }
    },
  },
  methods: {
    addInteraction(interaction) {
      if (!interaction) {
        return;
      }

      interaction.active = true;
    },

    removeInteraction(name) {
      const interaction = this.interactions.find((interaction) => interaction.name == name);

      if (!interaction) {
        return;
      }

      interaction.active = false;

      delete this.filters[`exclude_interactions_${interaction.name}`];
      delete this.filters[`max_interaction_days_${interaction.name}`];
      delete this.filters[`min_interaction_days_${interaction.name}`];
    },

    saveStimulus() {
      if (typeof this.profileKeyModel[0] != "string") {
        if (this.profileKeyModel.findIndex((item) => item == "Sem-perfil") >= 0) {
          this.profileKeyModel[this.profileKeyModel.findIndex((item) => item == "Sem-perfil")] = {
            name: "Sem-perfil",
          };
        }
        if (this.profileKeyModel[0] && this.profileKeyModel[0]["name"]) {
          if (this.profileKeyModel[0])
            this.profileKeyModel = this.profileKeyModel.map((item) => item.name);
        }
      } else {
        this.profileKeyModel.forEach((item) => {
          if (item["name"]) {
            let name = item["name"];
            this.profileKeyModel = this.profileKeyModel.filter((item2) => item2 !== item);
            this.profileKeyModel.push(name);
          }
        });
      }

      if (typeof this.segmentModel[0] != "string") {
        if (this.segmentModel.findIndex((item) => item == "Sem-segmento") >= 0) {
          this.segmentModel[this.segmentModel.findIndex((item) => item == "Sem-segmento")] = {
            name: "Sem-segmento",
          };
        }
        if (this.segmentModel[0] && this.segmentModel[0]["name"]) {
          this.segmentModel = this.segmentModel.map((item) => item.name);
        }
      } else {
        this.segmentModel.forEach((item) => {
          if (item["name"]) {
            let name = item["name"];
            this.segmentModel = this.segmentModel.filter((item2) => item2 !== item);
            this.segmentModel.push(name);
          }
        });
      }

      if (typeof this.dealTagsModelV2[0] != "string") {
        if (this.dealTagsModelV2.findIndex((item) => item == "Sem-tags") >= 0) {
          this.dealTagsModelV2[this.dealTagsModelV2.findIndex((item) => item == "Sem-tags")] = {
            name: "Sem-tags",
          };
        }
        if (this.dealTagsModelV2[0] && this.dealTagsModelV2[0]["name"]) {
          this.dealTagsModelV2 = this.dealTagsModelV2.map((item) => item.name);
        }
      } else {
        this.dealTagsModelV2.forEach((item) => {
          if (item["name"]) {
            let name = item["name"];
            this.dealTagsModelV2 = this.dealTagsModelV2.filter((item2) => item2 !== item);
            this.dealTagsModelV2.push(name);
          }
        });
      }

      if (typeof this.contactTagsModel[1] != "string") {
        if (this.contactTagsModel.findIndex((item) => item == "Sem-tags") >= 0) {
          this.contactTagsModel[this.contactTagsModel.findIndex((item) => item == "Sem-tags")] = {
            name: "Sem-tags",
          };
        }
        if (this.contactTagsModel[0] && this.contactTagsModel[0]["name"]) {
          this.contactTagsModel = this.contactTagsModel.map((item) => item.name);
        }
      }

      if (typeof this.customerTagsModel[1] != "string") {
        if (this.customerTagsModel.findIndex((item) => item == "Sem-tags") >= 0) {
          this.customerTagsModel[this.customerTagsModel.findIndex((item) => item == "Sem-tags")] = {
            name: "Sem-tags",
          };
        }
        if (this.customerTagsModel[0] && this.customerTagsModel[0]["name"]) {
          this.customerTagsModel = this.customerTagsModel.map((item) => item.name);
        }
      }

      if (this.newStimulus.daily_budget)
        this.newStimulus.daily_budget = parseFloat(this.newStimulus.daily_budget);

      if (this.campaigns.length) {
        this.filters.campaign = this.campaignModelV2;
      } else {
        delete this.filters.campaignModelV2;
      }
      if (this.amountDealsModel.length) {
        this.filters.amount_deals = this.amountDealsModel;
      } else {
        delete this.filters.amount_deals;
      }
      if (this.segmentModel.length) {
        this.filters.segments = this.segmentModel;
      } else {
        delete this.filters.segments;
      }
      if (this.profileKeyModel.length) {
        this.filters.creditor_profiles = this.profileKeyModel;
      } else {
        delete this.filters.creditor_profiles;
      }

      if (this.dealTagsModelV2.length) {
        this.filters.tags_v2 = this.dealTagsModelV2;
      } else {
        delete this.filters.tags_v2;
      }

      if (this.contactTagsModel.length) {
        this.filters.contact_tags_v2 = this.contactTagsModel;
      } else {
        delete this.filters.contact_tags_v2;
      }

      if (this.customerTagsModel.length) {
        this.filters.customer_tag = this.customerTagsModel;
      } else {
        delete this.filters.customer_tag;
      }

      if (this.responsibleTypes.length) {
        this.filters.responsible_types = this.responsibleTypes;
      } else {
        delete this.filters.responsible_types;
      }
      if (this.contactsSource.length) {
        this.filters.contacts_source = this.contactsSource;
      } else {
        delete this.filters.contacts_source;
      }
      if (this.filters.min_digit == "") delete this.filters.min_digit;
      if (this.filters.max_digit == "") delete this.filters.max_digit;
      if (this.filters.min_quality == "") delete this.filters.min_quality;
      if (this.filters.max_quality == "") delete this.filters.max_quality;
      if (this.filters.min_stimulation == "") delete this.filters.min_stimulation;
      if (this.filters.max_stimulation == "") delete this.filters.max_stimulation;
      if (this.filters.min_interaction_days == "") delete this.filters.min_interaction_days;
      if (this.filters.max_interaction_days == "") delete this.filters.max_interaction_days;
      if (this.filters.exclude_interactions == "") delete this.filters.exclude_interactions;
      if (this.filters.max_contact_count == "") delete this.filters.max_contact_count;
      if (this.filters.contact_age == "") delete this.filters.contact_age;
      if (this.filters.days_to_wait == "") delete this.filters.days_to_wait;

      this.newStimulus.filters = Object.assign({}, this.filters);
      this.newStimulus.last_modification_user = store.getters.getLoggedUser.name;
      this.newStimulus.ignore_optin = this.ignore_optin;

      if (this.newStimulus.id) this.edit();
      else this.new();
    },
    changeToTop() {
      if (this.toTop) {
        this.newStimulus.order = this.minOrder - 1;
      }
    },
    new() {
      this.changeToTop();
      stimulusService
        .create(this.newStimulus)
        .then(async () => {
          this.$store.commit("showSnackbar", {
            important: true,
            message: `${this.newStimulus.name} salvo com sucesso!`,
          });
          this.$emit("update:dialog", false);
        })
        .catch((e) => {
          this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
        });
    },
    edit() {
      let payload = {};
      Object.entries(this.newStimulus).forEach(([index, item]) => {
        switch (typeof item) {
          case "object":
            if (item && item.length && !this.isArraysEqual(item, this.dataTest[index])) {
              payload[index] = item;
            } else if (!this.isObjectsEqual(item, this.dataTest[index])) {
              payload[index] = item;
            }
            break;
          default:
            if (item != this.dataTest[index]) {
              if (index == "daily_budget" && item == "") payload[index] = null;
              else payload[index] = item;
            }
            break;
        }
      });
      delete payload.approach_flow;
      delete payload.created_at;
      delete payload.updated_at;
      delete payload.id;

      stimulusService
        .update(this.newStimulus.id, payload)
        .then(async (res) => {
          this.$store.commit("showSnackbar", {
            important: true,
            message: `${this.newStimulus.name} salvo com sucesso!`,
          });
          this.$emit("update:dialog", false);
        })
        .catch((e) => {
          this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
        });
    },
    isObjectsEqual(a, b) {
      // Create arrays of property names
      var aProps = Object.getOwnPropertyNames({ ...a });
      var bProps = Object.getOwnPropertyNames({ ...b });

      // If number of properties is different,
      // objects are not equivalent
      if (aProps.length != bProps.length) {
        return false;
      }

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
          return false;
        }
      }

      // If we made it this far, objects
      // are considered equivalent
      return true;
    },
    isArraysEqual(a, b) {
      let isEqual = true;
      a.forEach(([index, item]) => {
        if (item != b[index]) isEqual = false;
      });
      return isEqual;
    },
  },
};
</script>

<style>
#qj-dialog-stimulus .v-toolbar__content {
  padding-right: 0;
}
#qj-dialog-stimulus .v-speed-dial__list {
  align-items: end;
}
#qj-dialog-stimulus .v-speed-dial {
  bottom: 0;
}
#qj-dialog-stimulus .v-btn--floating {
  position: relative;
}
#qj-dialog-stimulus .v-avatar {
  cursor: alias;
  margin-left: 0;
}
.interaction-option {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
}

.qj-dialog-title-input.v-input input:hover {
  border: 1px solid #6a4cb7;
  border-radius: 4px;
  padding-right: 5px;
}

.qj-dialog-title-input.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
  padding-left: 0;
}
.qj-dialog-title-input.v-input__control > .v-input__slot {
  min-height: 48px;
}
.qj-dialog-title-input.v-text-field--full-width > .v-input__control > .v-input__slot {
  min-height: 28px !important;
}
.qj-dialog-title-input .v-label {
  margin-top: -12px;
}
.qj-dialog-title-input.v-input,
.qj-dialog-title-input .v-label {
  font-size: 24px !important;
  width: calc(100% - 36px);
}
.qj-dialog-title-input.v-input input,
.qj-dialog-title-input .v-label {
  padding-left: 2px;
}
.qj-dialog-title-input.v-input input:hover,
.qj-dialog-title-input .v-label:hover {
  padding-left: 1px;
}
.qj-dialog-title-input.v-input input:hover {
  border: 1px solid #6a4cb7;
  border-radius: 4px;
  padding-right: 1px;
}
.qj-dialog-title-input.v-input input:focus,
.qj-dialog-title-input .v-label:focus {
  padding-left: 0;
}
.qj-dialog-title-input.v-input input:focus {
  border: 2px solid #6a4cb7;
  border-radius: 4px;
  padding-right: 0;
}

.v-text-field--full-width.v-text-field--single-line input {
  margin-top: 0;
}


#qj-dialog-stimulus .v-subheader {
  height: unset !important;
}
</style>
